export default function StatsSection() {
  const stats = [
    { value: '20,000+', label: 'Verified Products', icon: 'ri-checkbox-multiple-line' },
    { value: '5,000+', label: 'Trusted Sellers', icon: 'ri-user-star-line' },
    { value: 'Daily', label: 'Fresh Updates', icon: 'ri-refresh-line' },
    { value: 'Thousands', label: 'Monthly Users', icon: 'ri-group-line' },
  ];

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <span className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-xl bg-accent-100/60 text-accent-600">
                <i className={`${stat.icon} text-lg`}></i>
              </span>
              <p className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-950 mb-1">
                {stat.value}
              </p>
              <p className="text-xs text-foreground-400 font-medium font-label tracking-wide">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}